'use client';

import '@ui5/webcomponents/dist/Table.js';
import { TableMode, TableGrowingMode } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `Table` component provides a set of sophisticated and convenient functions for responsive table design. It provides a comprehensive set of features for displaying and dealing with vast amounts of data.
 *
 * To render the `Table` properly, the order of the `columns` should match with the order of the item `cells` in the `rows`.
 *
 * Desktop and tablet devices are supported. On tablets, special consideration should be given to the number of visible columns and rows due to the limited performance of some devices.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-Table)
 */
const Table = withWebComponent('ui5-table', ['accessibleName', 'accessibleNameRef', 'busyDelay', 'growing', 'growingButtonSubtext', 'growingButtonText', 'mode', 'noDataText'], ['busy', 'hideNoData', 'stickyColumnHeader'], ['columns'], ['load-more', 'popin-change', 'row-click', 'selection-change']);
Table.displayName = 'Table';
Table.defaultProps = {
  busyDelay: 1000,
  growing: TableGrowingMode.None,
  mode: TableMode.None
};
export { Table };